import {FC, JSX, useEffect, useState} from "react";

import {useNavigate} from "react-router-dom";
import {checkAuth, getToken} from "../utils/Utils";
import {useAppDispatch} from "../hooks/useAppDispatch.ts";
import {setInitialDataTC} from "../state/reducers/user-reducer.ts";
import {LoaderComponent} from "../custom-components/loader/Loader.tsx";

interface Props {
    children: JSX.Element
}

export const ProtectedRoute: FC<Props> = ({children}) => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);
    const t = getToken();
    const isAuth = checkAuth();

    const init = async () => {
        if(!t){
            setLoading(false);
            navigate('/not_found');
        }else{

            await dispatch(setInitialDataTC(navigate));
            setLoading(false);
        }
    };
    useEffect(() => {
        init();
    }, []);


    if (loading) return <LoaderComponent/>;
    return isAuth && t && children;
}